<template>
<div class="hisOuterBox">
    <div class="contHis" :style="btnTop">
        <template v-for="(pic, idx) in historyPics" >
            <img :src="pic" :key="idx" class="hisPic" @click="changeOnNum(idx)" :class="picClass(idx)" :style="{'top': idx == 0 ? '140px': 140+(38+380)* idx+'px', 'opacity': idx == onNum - 1 ? '0' : '1'}">
        </template>
    </div>
    <div class="axisLineBox">
        <div class="onBtn" :style="{'top': 59+58* onNum+'px'}"></div>
        <div class="lineB">
            <span class="circlePoint upper"></span>
            <div class="axisLine"></div>
            <span class="circlePoint downner"></span>
        </div>
        <template v-for="(y, i) in years">
            <div class="years" :key="i" :class="yearClass(i)" :style="{'top': 65+58* i+'px', 'textAlign': i%2 == 0 ? 'right' : 'left'}" @click="changeOnNum(i)">
                {{y}}
            </div>
        </template>
        
    </div>
</div>
</template>
<script>
import pic2011 from '../../../static/images/dynamic/newEvents/2011.png'
import pic2012 from '../../../static/images/dynamic/newEvents/2012.png'
import pic2013 from '../../../static/images/dynamic/newEvents/2013.png'
import pic2014 from '../../../static/images/dynamic/newEvents/2014.png'
import pic2015 from '../../../static/images/dynamic/newEvents/2015.png'
import pic2016 from '../../../static/images/dynamic/newEvents/2016.png'
import pic2017 from '../../../static/images/dynamic/newEvents/2017.png'
import pic2018 from '../../../static/images/dynamic/newEvents/2018.png'
import pic2019 from '../../../static/images/dynamic/newEvents/2019.png'
import pic2020 from '../../../static/images/dynamic/newEvents/2020.png'
import pic2021 from '../../../static/images/dynamic/newEvents/2021.png'

export default {
    name: 'developHistory',
    data() {
        return {
            historyPics: [
                pic2021, pic2020, pic2019, pic2018, pic2017, pic2016,
                pic2015, pic2014, pic2013, pic2012, pic2011,
            ],
            years: [
                '2021年', '2020年','2019年','2018年', '2017年', '2016年',
                '2015年', '2014年','2013年', '2012年','2011年',
            ],
            onNum: 0
        }
    },
    computed: {
        btnTop(){                                
            const temp = {                    
                transform: 'translateY(-'+ ((38+380)* this.onNum) +'px)',                
             }                
             return temp;            
        }, 
    },
    methods: {
        yearClass(i) {
            let temp;
            if (i%2 == 0) {
                temp = 'rightPic';
                if (i == this.onNum) {
                    temp += ' onYearsR'
                }
            } else {
                temp = 'leftPic';
                if (i == this.onNum) {
                    temp += ' onYearsL'
                }
            }
            return temp;
        },
        picClass(i) {
            let tempPic = i%2 == 0 ? 'rightPic' : 'leftPic';
            tempPic += i == this.onNum + 1 ? ' bottomPic': ''
            return tempPic;
        },
        changeOnNum(i) {
            console.log(123, i)
            this.onNum = i;
        }
    }
}
</script>
<style scoped lang="less">
    .hisOuterBox{
        height:725px;
        width: 1089px;
        margin: 0 auto;
        overflow: hidden;
        position:relative;
    }
    .leftPic{
        left: 0;
    }
    .rightPic{
        right: 0;
    }
    .contHis{
        width: 1089px;
        height: 4000px;
        margin: 0 auto;
        position:absolute;
        transition: all 0.8s;
        .hisPic{
            width: 320px;
            height:380px;
            position:absolute;            
        }
        .bottomPic{
             mask: linear-gradient(#000 33%, transparent 43%)
        }
        
    }
    
    .axisLineBox{
        padding: 65px 0;
        position:relative;
        width:182px;
        margin: 0 auto;
        .onBtn{
            width: 14px;
            height: 14px;
            background: #FFFFFF;
            border: 6px solid #3A7EFF;
            border-radius: 50%;
            position:absolute;
            left: 78px;
            z-index:1000;
            transition: all 0.5s;
        }
        .years{
            position:absolute;
            width: 95px;
            height: 57px;
            font-size:18px;
            line-height:18px;
            // background:red;
            color: #3A7EFF;
            cursor:pointer;
        }
        .onYearsR{
            font-size:24px;
            width: 115px;
            right:-10px;
            font-weight:bold;
        }
        .onYearsL{
            font-size:24px;
            width: 115px;
            left: -10px;
            font-weight:bold;
        }
        .lineB{
            position:relative;
            .axisLine{
                height:574px;
                width: 0;
                border-left:4px dashed #3A7EFF; 
                margin:-1px auto;
            }
            .circlePoint{
                width: 14px;
                height:14px;
                border-radius: 50%;
                background: #3A7EFF;
                display:inline-block;
            }
        }
        
    }
    

</style>


// WEBPACK FOOTER //
// src/components/parts/developHistory.vue